export class CPFUtils {
    static invalidCPFs: string[] = [
        "00000000000",
        "11111111111",
        "22222222222",
        "33333333333",
        "44444444444",
        "55555555555",
        "66666666666",
        "77777777777",
        "88888888888",
        "99999999999"
    ];

    public static ValidarCPF(cnpj: string): boolean {
        if (!cnpj) return false;

        cnpj = cnpj.trim();
        cnpj = cnpj.split(".").join("").split("-").join("");
        if (cnpj.length != 11) return false;

        if (CPFUtils.invalidCPFs.includes(cnpj)) {
            return false;
        }

        let soma = 0;
        let resto: number;
        for (let i = 1; i <= 9; i++) soma = soma + parseInt(cnpj.substring(i - 1, i)) * (11 - i);
        resto = (soma * 10) % 11;

        if (resto == 10 || resto == 11) resto = 0;
        if (resto != parseInt(cnpj.substring(9, 10))) return false;

        soma = 0;
        for (let i = 1; i <= 10; i++) soma = soma + parseInt(cnpj.substring(i - 1, i)) * (12 - i);
        resto = (soma * 10) % 11;

        if (resto == 10 || resto == 11) resto = 0;
        if (resto != parseInt(cnpj.substring(10, 11))) return false;
        return true;
    }
}
